import _, { max } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import styles from './ZoomableImage.module.scss';
import moment from 'moment';

const ZoomableImage = (props) => {
    const { className = '', src, children, centerPosition, onImageClicked } = props,
        [cid] = useState(_.uniqueId('ZI-')),
        [preloaded, setPreloaded] = useState(false),
        [loaded, setLoaded] = useState(false),
        [imageSize, setImageSize] = useState({ width: 0, height: 0 }),
        ref = useRef(),
        wrapperRef = useRef(),
        [initialScale, setInitialScale] = useState(1),
        [scale, setScale] = useState(1),
        lastTransformRef = useRef(moment());

    useEffect(() => {
    }, [scale]);

    const handleTransformation = useCallback(({ state }) => {
        setScale(state.scale);
        lastTransformRef.current = moment();
    }, []);

    const handleLoaded = useCallback(() => {
        setLoaded(true);
        // setTimeout(() => wrapperRef.current?.resetTransform(), 1000);
    }, []);

    // Preload image and measure size
    useEffect(() => {
        let mounted = true;

        const image = new Image();
        image.onload = () => {
            if (mounted) {
                const { width: containerWidth, height: containerHeight } = ref.current.getBoundingClientRect();

                // Compute the scale factor needed for the image to just fit within the container.
                const initialScale = Math.min(containerWidth / image.width, containerHeight / image.height);

                setInitialScale(initialScale);
                setScale(initialScale);
                setImageSize({ width: image.width, height: image.height });
                setPreloaded(true);
            }
        };
        image.src = src;

        return () => (mounted = false);
    }, [src]);

    // Center image
    useEffect(() => {
        const { width, height } = imageSize,
            containerSize = ref.current.getBoundingClientRect();

        if (centerPosition) {
            const scale = max([1, containerSize.width / width, containerSize.height / height]),
                positionX = 0.5 * containerSize.width - centerPosition[0] * width * scale,
                positionY = 0.5 * containerSize.height - centerPosition[1] * height * scale;
            wrapperRef.current?.setTransform(positionX, positionY, scale);
        } else {
            wrapperRef.current?.resetTransform();
        }
    }, [centerPosition, loaded]);

    // Handle image click
    const handleImageClicked = useCallback(
        (e) => {
            if (moment().diff(lastTransformRef.current, 'seconds') < 0.5) return;

            if (onImageClicked) {
                const { offsetX, offsetY } = e?.nativeEvent;
                if (onImageClicked) {
                    onImageClicked(offsetX / imageSize.width, offsetY / imageSize.height);
                }
            }
        },
        [onImageClicked, imageSize]
    );

    // Render placeholder
    if (!preloaded) {
        return <div className={[className, styles.ZoomableImage].join(' ')} ref={ref} />;
    }

    return (
        <div id={cid} className={[className, styles.ZoomableImage].join(' ')} ref={ref}>
            <style
                dangerouslySetInnerHTML={{
                    __html: `
      #${cid} .Pin { transform: scale(${1 / scale});
    `,
                }}
            />
            <TransformWrapper ref={wrapperRef} centerOnInit initialScale={initialScale} minScale={0.1} onTransformed={handleTransformation}>
                <TransformComponent>
                    <div>
                        <div onClick={handleImageClicked}>
                            <img src={src} onLoad={handleLoaded} />
                        </div>
                        {React.Children.map(children, (child) => {
                            if (child) {
                                return React.cloneElement(child, imageSize);
                            }
                        })}
                    </div>
                </TransformComponent>
            </TransformWrapper>
        </div>
    );
};
export default ZoomableImage;
